<router-outlet></router-outlet>

@if (loader().isLoading) {
	<app-loader [loadingMessage]="loader().loadingMessage"></app-loader>
}

<div class="absolute right-4 top-4 z-10">
	<app-toast />
</div>
